import { useMarkerIo } from '@/hooks/use-markerio';
import Layout from '@/layout';
import { useEffect } from 'react';

interface LoggedInContainerProps {
  children: React.ReactNode;
}

const LoggedInContainer = ({ children }: LoggedInContainerProps) => {
  const { setReporter: setMarkerIoReporter } = useMarkerIo();

  useEffect(() => {
    setMarkerIoReporter();
  }, [setMarkerIoReporter]);

  return <Layout>{children}</Layout>;
};

export { LoggedInContainer };
